import React, { useEffect, createElement } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { ComparisonTable } from './components/ComparisonTable';
import { ForYouChecklist } from './components/ForYouChecklist';
import { Benefits } from './components/Benefits';
import { TomiSection } from './components/TomiSection';
import { BonusSection } from './components/BonusSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { CreatorQuote } from './components/CreatorQuote';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { OfferBanner } from './components/OfferBanner';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel
    const initPixel = () => {
      const f = window as any;
      if (f.fbq) return;
      const n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = !0;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        document.head.appendChild(t);
      }
      f.fbq('init', '757545003709827');
      f.fbq('track', 'PageView');
    };
    initPixel();
  }, []);
  return <div className="min-h-screen bg-brand-bg text-brand-text overflow-x-hidden pb-24 sm:pb-28" data-id="element-0">
      <UrgencyBanner data-id="element-1" />
      <div className="max-w-2xl mx-auto" data-id="element-2">
        <Hero data-id="element-3" />
        <PainSection data-id="element-4" />
        <ComparisonTable data-id="element-5" />
        <ForYouChecklist data-id="element-6" />
        <Benefits data-id="element-7" />
        <TomiSection data-id="element-8" />
        <BonusSection data-id="element-9" />
        <PricingCard data-id="element-10" />
        <Guarantee data-id="element-11" />
        <CreatorQuote data-id="element-12" />
        <Testimonials data-id="element-13" />
        <FAQ data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </div>
      <Footer data-id="element-16" />
      <SocialProofPopup data-id="element-17" />
      <OfferBanner data-id="element-18" />

      {/* Meta Pixel Noscript Fallback */}
      <noscript data-id="element-19">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=757545003709827&ev=PageView&noscript=1" alt="" data-id="element-20" />
      </noscript>
    </div>;
}